// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".562.0.0." + {2239: "9560e3910ba04d12",2733: "ecba580577c841a8",2944: "0dbc4f0d0debfcd7",5233: "dde5e9008c61a6a5",5338: "7c019e4b1a715154",8756: "27d8adf3102c96a6",9289: "18615d1a458e3d03",}[chunkId] + ".css"
}